var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"windowListItem",staticClass:"windowListItem",class:{active: _vm.active},on:{"click":_vm.onClick}},[_c('span',{staticClass:"order"},[_vm._v(_vm._s(_vm.index + 1))]),_c('canvas',{ref:"canvas",staticClass:"windowListItemCanvas"})])
}
var staticRenderFns = []

export { render, staticRenderFns }